import React, { PureComponent } from 'react';
import { Currency } from '~/Api/Currency';
import altSelectStyles from '~/UI/Select/alt.less';
import Select from '~/UI/Select/Select';

interface Props {
	id: string | null;
	currencies: Currency[] | null;
	currentCurrency: string | null;
	excludeSourcePrice: boolean;
	onLoad(): any;
	onChange(code: string): void;
}

export default class CurrencySelect extends PureComponent<Props> {
	static defaultProps = {
		excludeSourcePrice: false,
	};

	componentDidMount() {
		this.props.onLoad();
	}

	render() {
		const { id, currencies, currentCurrency, excludeSourcePrice } = this.props;

		return currencies ? (
			<Select
				id={id || undefined}
				styles={altSelectStyles}
				value={String(currentCurrency)}
				onChange={this.valueChanged}
			>
				{excludeSourcePrice ? null : <option value=''>Source</option>}
				{currencies.map((currency) => (
					<option key={currency.code} value={currency.code}>
						{currency.code}
					</option>
				))}
			</Select>
		) : null;
	}

	valueChanged = (event: React.ChangeEvent<HTMLSelectElement>) => {
		this.props.onChange(event.target.value);
	};
}
